/*----------------------------------------------------------------------------*\
    Loader
    Simple loader script
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if nh object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/**
 * Component
 */
oy.loader = {
    threshold: 500,
    loaderTemplate: '<div class="c-loader__bouncer"></div>',

    /**
     * Test template
     */
    test: function ($loaders) {
        var self = this;

        setTimeout(function () {
            for (var i = 0; i < $loaders.length; ++i) {
                var $loader = $loaders[i];
                self.open($loader);
            }
        }, 1000);

        if(document.querySelector('.js--loader__toggle-test') && document.querySelector('.js--loader__toggle-all')) {
            document.querySelector('.js--loader__toggle-test').addEventListener('click', function () {
                self.close($loaders[0]);
            });
            document.querySelector('.js--loader__toggle-all').addEventListener('click', function () {
                self.closeAll(document);
            });
        }
    },


    /**
     * Open the modal
     */
    open: function ($container) {
        var self = this;

        if ($container === null) {
            return false;
        }

        var inCard = $container.closest('.o-card');
        var containerHeight = $container.offsetHeight;
        var windowHeight = window.innerHeight;
        var ratio = parseFloat(windowHeight/containerHeight);
        var $loaderTemplate = self.getLoaderTemplate();

        /**
         * If the `c-loader` is not present create it
         */
        window.requestAnimationFrame(function(){
            $container.classList.add('c-loader', 'js--loader');

            if (ratio < 0.75) {
                $container.classList.add('c-loader--sticky');
                $loaderTemplate.classList.add('js--sticky');
            }

            // incard check
            if (inCard) {
                $container.classList.add('is-incard');
            }
        });

        /**
         * Only display loader after a certain amount of time is passed
         * (self.threshold)
         */
        var loaderTimeout = setTimeout(function () {
            window.requestAnimationFrame(function(){
                $container.insertBefore($loaderTemplate, $container.firstChild);
                oy.sticky.setup($container);
                $container.classList.add('is-loading');
            });
        }, self.threshold);

        $container.loaderCallback = loaderTimeout;
    },

    close: function ($container) {
        if (typeof $container.loaderCallback !== 'undefined') {
            clearTimeout($container.loaderCallback);
        }
        window.requestAnimationFrame(function(){
            $container.classList.remove('is-loading');
            $container.classList.remove('c-loader');
            setTimeout(function () {
                var loaderTemplate = $container.querySelector('.js--loader__spinner');
                window.requestAnimationFrame(function(){
                    if (loaderTemplate) {
                        $container.removeChild(loaderTemplate);
                    }
                });
            }, oy.settings.transitions.medium);
        });
    },

    closeAll: function ($context) {
        if (!$context) {
            $context = document;
        }
        var self = this;
        var $loaders = $context.querySelectorAll('.js--loader');

        for (var i = 0; i < $loaders.length; ++i) {
            var $loader = $loaders[i];
            self.close($loader);
        }
    },

    getLoaderTemplate: function () {
        var $loader = document.createElement('div');
        $loader.classList.add('c-loader__spinner', 'js--loader__spinner');
        $loader.innerHTML = this.loaderTemplate;
        return $loader;
    }
};

window.addEventListener('load', function () {
    var $loaders = document.querySelectorAll('.js--loader__test');

    if ($loaders && $loaders.length) {
        oy.loader.test($loaders);
    }
}, false);
